module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/project-type-3-71d7c3b748b67dc305d1fb0197d60b59.svg";